import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import {
  brandedModalQuery,
  brandedModalQueryVariables,
} from '../../types/generated/brandedModalQuery';

export const BrandedModalQuery = gql`
  query brandedModalQuery($input: SiteBrandingInput!) {
    siteBranding(input: $input) {
      subdomain

      entityBrandings {
        name
        displayName
        teamName
        kind
        email
        phone
        showBranding
        logo {
          id
          baseUrl
          url
        }
        entityId
        socialBranding {
          facebook
          twitter
          linkedin
        }
        whiteLabel {
          isLogoTransparent
          headerBackgroundColor
        }
      }
    }
  }
`;

export const useBrandedProModalQuery = (
  options: QueryHookOptions<brandedModalQuery, brandedModalQueryVariables>
) =>
  useQuery<brandedModalQuery, brandedModalQueryVariables>(
    BrandedModalQuery,
    options
  );
